const translations = {
  app_name: "FormWeg",
  auth: {
    username: "Benutzername oder E-Mail",
    unauthorized: "Login fehlgeschlagen",
    back_to_login: "Zurück zum Login",
    remember_me: "Merken",
    sign_in: "Anmelden",
    forgot_password: "Passwort vergessen",
    forgot_password_alert: "E-Mail mit Anweisungen zum zurücksetzen wurde versendet",
    password_confirm_error: "Passwörter müssen übereinstimmen",
    submit: "Senden",
    password: "Passwort",
    password_confirm: "Passwort wiederholen",
    reset_password_alert: "Ihr Passwort wurde zurück gesetzt",
    reset_token_expired: "Der Link ist leider abgelaufen",
    password_policy: {
      number: "Passwort muss mindestens eine Zahl enthalten",
      length: "Passwort muss mindestens 8 Zeichen lang sein",
      special: "Passwort muss mindestens ein Sonderzeichzen enthalten",
      uppercase: "Passwort muss mindestens ein Großbuchstaben enthalten",
      lowercase: "Passwort muss mindestens ein Kleinbuchstaben enthalten",
    },
  },
  menu: {
    home: "Start",
    actions: "Aktionen",
    documentation: "Dokumentation",
    documentation_short: "Doku",
    files: "Bilder & Dateien",
    note: "Notiz",
    notes: "Notizen",
    comment: "Kommentar",
    comments: "Kommentare",
    remark: "Bemerkung",
    items: "Artikel",
    users: "Benutzer",
    customers: "Kunden",
    customer_properties: "Objekte",
    help: "Hilfe",
    feedback: "Anfrage",
    settings: "Einstellungen",
    logout: "Abmelden",
    translations: "Bezeichnungen",
    integrations: "Schnittstellen",
    search: "Suche",
    filter: "Filter",
    all: "Alle",
    deleted: "Gelöscht",
    import: "Import",
    export: "Export",
    more: "Mehr",
    add: "Hinzufügen",
    edit: "Ändern",
    next: "Weiter",
    previous: "Zurück",
    from: "von",
    to: "bis",
    cancel: "Abbrechen",
    submit: "Speichern",
    review: "Zur Bearbeitung",
    bill: "Zur Abrechnung",
    bill_or_review: "In Bearbeitung",
    billed: "Abgerechnet",
    canceled: "Verworfen",
    inspection: "Zur Wartung",
    inspections: "Inspektionen",
    inspection_cards: "Inspektionen",
    draft: "Entwurf",
    drafts: "Entwürfe",
  },
  items: {
    item: "Artikel",
    highlight: "In Dokumentübersicht hervorheben",
    highlight_short: "Hervorheben",

    inspect_every_x_months: "Intervall (Monate)",
    line: "Pos",
    inspect_interval_months: "Inspektion in Monaten",
    items: "Artikel",
    itemp: "Artikel",
    name: "Artikel",
    amount: "Menge",
    details: "Artikel Details",
    number: "Nummer",
    description: "Beschreibung",
    attributes: {
      choice: "Option",
      menu: {
        add_choice: "Option anlegen",
        select_choice: "Option auswählen",
      },
    },
    groups: {
      group: "Gruppe",
      ungrouped: "Ohne Gruppe",
      rename: "Gruppe umbenennen",
    },

    characteristics: {
      characteristic: "Merkmal",
      different: "Mit unterschiedlichen Merkmalen",
      simular: "Mit gleichartigen Merkmalen",
      unique: "Mit einzigartigen Merkmalen",
      short: {
        different: "",
        simular: "Gleichartig",
        unique: "Einzigartig",
      },
    },
  },
  customers: {
    new: "Neuer Kunde",
    number: "Kunden Nr.",
    customers: "Kunden",
    customer: "Kunde",
    not_found: "Kunde nicht gefunden",
    search_unavailable: "Kundensuche nicht verfügbar da kein ERP System angebunden ist",
    service_unavailable: "SQLBase ist derzeit nicht erreichbar. Bitte prüfen Sie die Netzwerkverbindung.",
    name: "Name",
    properties: {
      search: "Objekt Suche...",
      //street: "Objekt Straße",
      //zip: "Objekt Postleitzahl",
      //city: "Objekt Stadt",
      //district: "Objekt Bezirk",
      name: "Objekt Name",
      number: "Objekt Nr.",
      properties: "Objekte",
      property: "Objekt",
      contact: "Kontakt",
      address: "Adresse",
    },

    assigned_to: "Zuständiger Prüfer",
    assign_to_me: "Mir zuweisen",
    unassigned: "Nicht zugewiesen",

    menu: {
      search: "Kunde",
      signature: "Unterschrift",
    },
  },
  contacts: {
    contact: "Kontakt",
  },
  delivery_notes: {
    delivery_notes: "Formulare",
    delivery_note: "Formular",
    number: "Nummer",
    date: "Datum",
    next_date_of_inspection: "Fällig",
    menu: {
      add: "Hinzufügen",
      add_2: "Anlegen",
      save: "Speichern",
      change: "Ändern",
      completed: "Fertigstellen",
      confirm_completed:
        "$t(delivery_notes.delivery_note) wirklich fertigstellen? Danach kann er nicht mehr als Entwurf bearbeitet werden.",
      confirm_reviewed: "$t(delivery_notes.delivery_note) wirklich als geprüft markieren?",
      confirm_billed: "$t(delivery_notes.delivery_note) wirklich als abgerechnet markieren?",
      confirm_canceled: "$t(delivery_notes.delivery_note) wirklich stornieren?",
      confirm_copy: "$t(delivery_notes.delivery_note) wirklich kopieren?",
      advancing_next: "Weiter zum nächsten $t(delivery_notes.delivery_note)…",
      status: "Status",
      draft: "Speichern",
    },
    status: {
      due: "Fällig",
    },
    assigned_to: "Bearbeiter",
    assign_to_me: "Mir zuweisen",
    unassigned: "Nicht zugewiesen",
    auto_items_group: "Deine häufigsten Artikel",
    custom_group: "Eigene",
    removed_from_template: "Nicht mehr in {{name}} Vorlage enthalten",
    coworkers: "Kooperation",
    coworker_badge: "Kooperation",
    states: {
      drafted: "Entwurf",
      pending: "Ausstehend",
      delivered: "Geliefert",
      reviewed: "Geprüft",
      billed: "Abgerechnet",
      canceled: "Verworfen",
    },

    templates: {
      template: "Vorlage",
      templates: "Vorlagen",
      name: "Name",
      items: "Artikel",
      item_count: "Artikel",
      created_by: "Erstellt von",
      search_item: "Artikel suchen",
      no_items: "Keine Artikel zugewiesen",
      no_documentation: "Keine Dokumentation konfiguriert",
      add_column: "Spalte",
      add_row: "Zeile",
      col_name: "Spaltenname",
      default_value: "Standardwert",
      choices_hint: "Optionen (kommagetrennt)",
      types: {
        text: "Text",
        checkbox: "Checkbox",
        select: "Auswahl",
      },
    },
    alerts: {
      reviewed: "$t(delivery_notes.delivery_note) ist bereits als geprüft markiert und kann nicht mehr verändert werden.",
    },
    customer: {
      no_signature: "Keine Kundenunterschrift!",
      no_signature_reason: "Keine Unterschrift, durchgeführte Arbeiten zuvor besprochen und bestätigt",
    },
    errors: {
      number_already_exists: "Artikelnummer existiert bereits im $t(delivery_notes.delivery_note)",
    },
  },

  users: {
    users: "Benutzer",
    user: "Benutzer",
    name: "Name",
    username: "Benutzername",
    email: "E-Mail",
    number: "Nummer",
    active: "Aktiv",
    status: "Status",
    roles: "Rollen",
    role: "Rolle",
    role_names: {
      administrator: "Administrator",
      manager: "Manager",
      technician: "Techniker",
      office: "Büro",
    },
    password: "Passwort",
    send_reset_password: "Passwort zurücksetzen Mail senden",
    reset_password_sent: "E-Mail zum Zurücksetzen des Passworts wurde gesendet",
    reset_password_error: "Fehler beim Senden der E-Mail",
    reset_password_admin_only: "Nur Administratoren können Passwörter zurücksetzen",
    login_info: "Login-Info",
    login_count: "Anmeldungen",
    current_login_at: "Aktuelle Anmeldung",
    current_login_ip: "Aktuelle IP",
    last_login_at: "Letzte Anmeldung",
    last_login_ip: "Letzte IP",
    never_logged_in: "Noch nie angemeldet",
  },

  invoices: {
    number: "Rechnungs Nr.",
  },

  address: {
    name: "Name",
    street: "Straße",
    zip: "Postleitzahl",
    district: "Bezirk",
    city: "Stadt",
    state: "Bundesland",
    country: "Land",
    menu: {
      from: "Von",
      to: "An",
    },
  },

  errors: {
    item: {
      number_exists: "Ein Artikel mit dieser Nummer existiert bereits",
    },
    delivery_note: {
      invalid_transition: "Übergang von {{from}} nach {{to}} ist nicht erlaubt",
      transition_forbidden: "Übergang von {{from}} nach {{to}} ist für Ihre Rolle nicht erlaubt",
    },
    users: {
      already_exists: "Ein Benutzer mit diesem Benutzernamen oder dieser E-Mail existiert bereits",
    },
    unknown: "Ein unbekannter Fehler ist aufgetreten",
    types: {
      number: {
        number: "Wert muss einer Zahl entsprechen",
        positive: "Wert muss einer positiven Zahl entsprechen",
      },
    },
  },

  permissions: {
    can_not_edit: "Keine Rechte zum editieren",
  },

  common: {
    back: "Zurück",
    position: "Position",
    line: "Pos",
    create: "Anlegen",
    number_short: "Nr.",
    full_name: "Vollständiger Name",
    name: "Name",
    employee: "Mitarbeiter",
    expert: "Mitarbeiter",
    add: "Hinzufügen",
    remove: "Entfernen",
    edit: "Editieren",
    copy: "Kopieren",
    print: "Drucken",
    send_email: "Per E-Mail senden",
    copy_link: "Link kopieren",
    link_copied: "Link wurde in die Zwischenablage kopiert",
    email_sent: "E-Mail wurde versendet",
    email_copy_sent_to: "Kopie an: {{email}}",
    recipient: "Empfänger",
    subject: "Betreff",
    message: "Nachricht",
    send: "Senden",
    attachments: "Anhänge",
    attachments_too_large: "Anhänge überschreiten das Limit von 10 MB",
    select: "Auswählen",
    months: "Monate",
    reset: "Zurücksetzten",
    undo: "Rückgängig",
    created_by: "Erstellt von",
    updated_by: "Geändert von",
    lock: "Sperren",
    unlock: "Entsperren",
    cancel: "Abbrechen",
    confirm: "Bestätigen",
    close: "Schließen",
    confirm_unsaved_changes:
      "Es gibt ungespeicherte Änderungen. Möchten Sie die Seite wirklich verlassen?",
    save: "Speichern",
    delete: "Löschen",
    confirm_delete: "Möchten Sie diesen Eintrag wirklich löschen?",
    saved: "Gespeichert",
    deleted: "Gelöscht",
    customer_signed: "Vom Kunden unterschrieben",
    date: {
      from: "vom",
    },
  },

  comments: {
    add: "Kommentar hinzufügen",
    add_placeholder: "Kommentar schreiben...",
    delete: "Kommentar löschen",
    confirm_delete: "Möchten Sie diesen Kommentar wirklich löschen?",
    edited: "bearbeitet",
  },

  files: {
    confirm_delete: "Möchten Sie diese Datei wirklich löschen?",
  },

  transcription: {
    recording: "Aufnahme läuft...",
    transcribing: "Wird transkribiert...",
    error: "Transkription fehlgeschlagen",
    mic_denied: "Mikrofonzugriff verweigert",
  },

  inspections: {
    title: "Inspektionen",
    month: "Monat",
    year: "Jahr",
    month_invalid: "Ungültiger Monat",
    inspector: "Prüfer",
    customer_nr: "Kundennr.",
    customer: "Kunde",
    property_nr: "Objektnr.",
    property: "Objekt",
    device_type: "Gerätetyp",
    next_inspection: "Nächste Prüfung",
    last_inspection: "Letzte Prüfung",
    schedule: "Termine",
    interval: "Intervall",
    card: "Inspektion",
    code: "Code",
    remark: "Bemerkung",
    communications: "Kommunikation",
    medium: "Medium",
    number: "Nummer",
    quantity: "Menge",
    no_results: "Keine Prüfungen gefunden",
    tunnel_unavailable: "SQLBase ist derzeit nicht erreichbar. Bitte prüfen Sie die Netzwerkverbindung.",
    tab_list: "Liste",
    tab_map: "Karte",
    map_stats: "{{located}} von {{total}} angezeigt — {{unlocated}} Adressen konnten nicht lokalisiert werden",
    map_loading: "Karte wird geladen...",
    map_empty: "Keine Prüfungen für den gewählten Filter vorhanden.",
    map_error: "Kartendaten konnten nicht geladen werden.",
    map_legend: "Legende",
    map_legend_unknown: "Unbekannt",
  },

  nominatim: {
    unavailable:
      "Der Kartendienst ist derzeit nicht erreichbar. " +
      "Adressen können nicht auf der Karte angezeigt werden.",
    unavailable_short: "Kartendienst nicht erreichbar",
  },

  settings: {
    translations: {
      title: "Bezeichnungen",
      description: "Bezeichnungen für Menüpunkte und Formulare anpassen",
      delivery_notes_plural: "Formulare (Plural)",
      delivery_notes_singular: "Formular (Singular)",
      templates_plural: "Vorlagen (Plural)",
      templates_singular: "Vorlage (Singular)",
    },
    natrav: {
      title: "Sichere Verbindung (Tunnel)",
      service: "Service",
      server: "Server",
      token: "Token",
      lokal: "Lokal",
      port: "Port",
      test: "Verbindung testen",
      tunnel_ok: "Tunnel erreichbar",
      tunnel_failed: "Tunnel nicht erreichbar",
    },
    sqlbase: {
      title: "SQLBase",
      db_name: "Datenbankname",
      username: "Benutzername",
      password: "Passwort",
      confirm_overwrite: "Vorhandene Einstellungen überschreiben?",
      test: "Verbindung testen",
      connection_ok: "Datenbankverbindung erfolgreich",
      connection_failed: "Datenbankverbindung fehlgeschlagen",
      authorization_title: "Autorisierung zum lesenden Datenbankzugriff",
      authorization_accept: "Akzeptieren",
      authorization_accepted_by: "Akzeptiert von {{name}} am {{date}} für {{db_name}} ({{version}})",
    },
  },

  form: {
    errors: {
      required: "{{attr}} is notwendig",
      email: "Bitte eine gültige E-Mail-Adresse eingeben",
    },
  },
};

export default translations;
